import { StaticImageData } from 'next/image';
import Link from 'next/link';

import XImage from '@/components/@base/x-image';

type BannerProps = {
  image: StaticImageData;
  link: string;
  alt: string;
};
export default function Banner({ image, link, alt }: BannerProps) {
  return (
    <Link href={link} passHref prefetch={false}>
      <XImage
        src={image}
        alt={alt}
        width={500}
        height={500}
        className=' bg-[#1B1B1B] object-contain md:mr-0'
      />
    </Link>
  );
}
